import axios from "./axios-handler.service";

const BASE_URL = "/api/certificadointer/";

export interface ConfigurarCertificadoInterCommand {
  validade: Date;
  arquivoCrt: File;
  arquivoKey: File;
}

export class CertificadoInterService {
  static async obterConfiguracao() {
    const response = await axios.get(`${BASE_URL}obter`);
    return response.data;
  }

  static async configurar(command: ConfigurarCertificadoInterCommand) {
    const arquivoCrtBase64 = await this.fileToBase64(command.arquivoCrt);
    const arquivoKeyBase64 = await this.fileToBase64(command.arquivoKey);

    const response = await axios.post(`${BASE_URL}Configurar`, {
      validade: command.validade,
      arquivoCrtBase64,
      arquivoKeyBase64,
    });

    return response.data;
  }

  private static fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () =>
        resolve((reader.result as string)?.replace(/^data:(.*,)?/, ""));
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
}
